import React from 'react';
import { LuBuilding2 } from 'react-icons/lu';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

type TenantOption = {
    tenantGUID: string;
    name: string;
};

export const WorkspaceSettingBanner = ({
    resourceLabel,
    availableTenants,
    currentTenant,
    disabled = false,
    onTenantChange,
}: {
    resourceLabel: string;
    availableTenants: TenantOption[];
    currentTenant: TenantOption;
    disabled?: boolean;
    onTenantChange: (tenantGUID: string) => void;
}) => {
    const currentTenantName = currentTenant.name || 'this workspace';

    const handleTenantChange = (tenantGUID: string) => {
        if (tenantGUID && tenantGUID !== currentTenant.tenantGUID) {
            onTenantChange(tenantGUID);
        }
    };

    return (
        <div className="text-foreground mb-5 flex flex-col gap-4 rounded-lg bg-cyan-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex min-w-0 items-start gap-4">
                <LuBuilding2 className="mt-1 size-5 shrink-0" />
                <p className="min-w-0 text-base leading-7 sm:text-lg">
                    <span className="font-semibold">Workspace setting.</span> {resourceLabel} are shared — changes here
                    apply to everyone in <span className="font-semibold">{currentTenantName}</span>.
                </p>
            </div>
            <Select
                value={currentTenant.tenantGUID || undefined}
                onValueChange={handleTenantChange}
                disabled={!currentTenant.tenantGUID || availableTenants.length === 0 || disabled}
            >
                <SelectTrigger
                    aria-label={`Select tenant for ${resourceLabel.toLowerCase()}`}
                    className="h-10 w-full min-w-[160px] shrink-0 rounded-full border-cyan-200 bg-white px-4 text-base font-semibold shadow-sm sm:w-auto [&>svg]:opacity-70"
                >
                    <div className="flex min-w-0 items-center gap-2">
                        <LuBuilding2 className="size-4 shrink-0" />
                        <SelectValue placeholder="Tenant" />
                    </div>
                </SelectTrigger>
                <SelectContent align="end">
                    {availableTenants.map((tenant) => (
                        <SelectItem key={tenant.tenantGUID} value={tenant.tenantGUID}>
                            {tenant.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
};
